import Vue from 'vue';
import Vuex from 'vuex';
import { wrapResponse, getJSON, postJSON } from '@/utils/http'


Vue.use(Vuex)
const store = new Vuex.Store({
    state () {
      return {
        count: 0,
        dist_name_list: null, //地区列表
        age_list: null, //年龄列表
        sex: null, //性别列表
        wish: null, //心愿列表
        platformMoney: '',
        initShare: false,
      }
    },
    mutations: {
      increment (state) {
        state.count++
      },
      'changestate'(state,data){
        for(const key in data){
          state[key] = data[key];
        }
      },
      'UPDATE_INFO'(state,data){
        console.log(data, 'data')
        state.dist_name_list = data.dist_name_list || [];
        state.age_list = data.age_list || [];
        state.sex = data.sex || [];
        state.wish = data.wish || [];
        state.platformMoney = data.total_amount || 0;
      }
    },
    actions: {
      // 获取全局信息
    async GetGlobalInfo({ commit }) {
      wrapResponse(getJSON('/api/wxy/configList'), false).then(res => {
        if(res.Code == 200){
          commit('UPDATE_INFO', res.Data)
        }else{
          commit('UPDATE_INFO', {})
        }
      })
    },
    }
    
})

export default store;